import React from 'react';
import { Link } from 'react-router-dom';
import { getInitials, formatHandicap } from '../utils/format';
import './UserCard.css';

function UserCard({ user, showDistance = true, actionButton }) {
  const getPlayingStyleLabel = (style) => {
    const labels = {
      casual: 'Casual',
      competitive: 'Competitive',
      social: 'Social'
    };
    return labels[style] || style;
  };

  return (
    <div className="user-card card">
      <Link to={`/golfer/${user.id}`} className="user-card-link">
        <div className="user-card-header">
          <div className="avatar avatar-lg">
            {user.photo_url ? (
              <img src={user.photo_url} alt={user.name} />
            ) : (
              getInitials(user.name)
            )}
          </div>
          <div className="user-card-info">
            <h3 className="user-card-name">{user.name}</h3>
            {user.home_course && (
              <p className="user-card-course">{user.home_course}</p>
            )}
            <p className="user-card-location">
              {user.city}{user.state && `, ${user.state}`}
              {showDistance && user.distance !== undefined && (
                <span className="user-card-distance"> - {user.distance} mi</span>
              )}
            </p>
          </div>
        </div>

        <div className="user-card-stats">
          <div className="user-card-stat">
            <span className="stat-value">{formatHandicap(user.handicap) || 'No handicap'}</span>
            <span className="stat-label">Handicap</span>
          </div>
          {user.playing_style && (
            <div className="user-card-stat">
              <span className="stat-value">{getPlayingStyleLabel(user.playing_style)}</span>
              <span className="stat-label">Style</span>
            </div>
          )}
          {user.pace_preference && (
            <div className="user-card-stat">
              <span className="stat-value" style={{ textTransform: 'capitalize' }}>{user.pace_preference}</span>
              <span className="stat-label">Pace</span>
            </div>
          )}
        </div>

        {user.bio && (
          <p className="user-card-bio">{user.bio}</p>
        )}
      </Link>

      {actionButton && (
        <div className="user-card-actions">
          {actionButton}
        </div>
      )}
    </div>
  );
}

export default UserCard;
